export const environment = {
  production: true,
  apiUrl: "https://api.memechua.com",
  mainUrl: "https://memechua.com",
  cmsUrl: "https://cms.memechua.com",
};
